import React, { Fragment } from 'react'

import { SectionsList } from './SectionsList'
import { SectionName } from '../../constants'
import type { ProductsShelfProps } from '../ProductsShelf'
import { ProductsShelf } from '../ProductsShelf'
import type { SearchShelfProps } from '../SearchShelf'
import { SearchShelf } from '../SearchShelf'
import type { Section } from '../../types'
import { usePartitionedSections } from './hooks'
import type { CollectionsShelfProps } from '../CollectionsShelf'
import { CollectionsShelf } from '../CollectionsShelf'

export type SectionsRenderProps = {
  sections: readonly Section[]
}

export const SectionsRender = ({
  sections: initialSections,
}: SectionsRenderProps) => {
  const { partitionedSections } = usePartitionedSections(initialSections)

  return (
    <SectionsList>
      {partitionedSections.map(
        (partitionedSection, partitionedSectionIndex) => (
          <Fragment key={partitionedSectionIndex}>
            {partitionedSection.map((section) => {
              if (section.name === SectionName.ProductsShelf) {
                return (
                  <ProductsShelf
                    data-testid={`product-shelf-${section.id}`}
                    key={section.id}
                    {...(section.data as ProductsShelfProps)}
                  />
                )
              }

              if (section.name === SectionName.SearchShelf) {
                return (
                  <SearchShelf
                    key={section.id}
                    {...(section.data as SearchShelfProps)}
                  />
                )
              }

              if (section.name === SectionName.CollectionShelf && section.id) {
                return (
                  <CollectionsShelf
                    key={section.id}
                    {...(section.data as CollectionsShelfProps)}
                  />
                )
              }

              return null
            })}
          </Fragment>
        )
      )}
    </SectionsList>
  )
}
